import React from 'react';
import { CategoriesWidgetGrid } from './CategoriesWidgetGrid/CategoriesWidgetGrid';
import { CategoriesWidgetSlider } from './CategoriesWidgetSlider/CategoriesWidgetSlider';

const CategoriesWidget = ({
    categoriesOnHomepageEnabled,
    categoriesWidgetRedesignEnabled,
    categories,
    isMobileUser,
}) => {
    if (!categoriesOnHomepageEnabled) return null;

    return categoriesWidgetRedesignEnabled ? (
        <CategoriesWidgetSlider categories={categories} isMobileUser={isMobileUser} />
    ) : (
        <CategoriesWidgetGrid categories={categories} isMobileUser={isMobileUser} />
    );
};

export default CategoriesWidget;
